import React from "react";
import { motion } from "framer-motion";
import { FaLinkedin } from "react-icons/fa";

import team1 from "../assets/team1.jpg";
import team2 from "../assets/team2.jpg";
import team3 from "../assets/team3.jpg";
import team4 from "../assets/team4.jpeg";
import team5 from "../assets/team5.jpg";
import team6 from "../assets/team6.jpg";
import advisor from "../assets/advisor.jpg";

const OurTeam = () => {
  const advisoryTeam = [
    {
      img: team1,
      name: "Siba Prasad",
      role: "Co-founder & President",
      linkedin: "https://www.linkedin.com/",
    },
    {
      img: team2,
      name: "Ninibala Jena",
      role: "Co-founder & Vice-President",
      linkedin: "https://www.linkedin.com/",
    },
    {
      img: advisor,
      name: "Prof. Dr. Sanjat Ku. Sahu",
      role: "Chief Advisor & Executive Board Member",
      linkedin: "https://www.linkedin.com/in/prof-dr-sanjat-kumar-sahu-72b218347/",
    },
  ];

  const executiveTeam = [
    {
      img: team3,
      name: "Biswajit Samantaray",
      role: "Co-founder & CEO",
      linkedin: "https://www.linkedin.com/in/biswajit-samantaray-6b3b4b1b8/",
    },
    {
      img: team4,
      name: "Sandeep Rout",
      role: "Co-Founder & Chief Finance & Operating Officer",
      linkedin: "https://www.linkedin.com/in/sandeep-rout-829904188/",
    },
    {
      img: team5,
      name: "Sakti Prasad",
      role: "Co-Founder & Chief, Research & Scientific Affairs",
      linkedin: "https://www.linkedin.com/in/sakti-p-pattnayak-89a402190/",
    },
    {
      img: team6,
      name: "Manas Barik",
      role: "Co-Founder & Chief, Programmes & Partnerships",
      linkedin: "https://www.linkedin.com/in/manas-barik-070042129/",
    },
  ];

  const TeamCard = ({ member, index, featured = false }) => (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      whileHover={{ y: -8 }}
      className={`group relative bg-gray-900 rounded-2xl overflow-hidden shadow-xl border border-gray-800 hover:border-lime-400/50 transition-all duration-300 ${
        featured ? "md:scale-105" : ""
      }`}
    >
      {/* Lime accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-lime-400"></div>

      {/* Image */}
      <div className="relative overflow-hidden">
        <img
          src={member.img}
          alt={member.name}
          className="w-full h-72 object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
      </div>

      {/* Details */}
<div className="p-6 text-center">

  {/* Name + LinkedIn */}
  <div className="flex items-center justify-center gap-2 mb-2">
    <h3 className="text-xl font-bold text-lime-400">
      {member.name}
    </h3>

    <a
      href={member.linkedin}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`LinkedIn profile of ${member.name}`}
      className="text-gray-400 hover:text-lime-400 transition-all duration-300 hover:scale-110"
    >
      <FaLinkedin size={21} />
    </a>
  </div>

  {/* Role */}
  <p className="text-gray-300 text-sm leading-relaxed">
    {member.role}
  </p>

</div>
    </motion.div>
  );

  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}
      <section
        className="relative min-h-[55vh] flex items-center justify-center overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: `url(${require("../assets/team-hero.png")})`,
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 text-center max-w-4xl mx-auto px-6">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            The People Behind ACoT
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            OUR <span className="text-lime-400">TEAM</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            Meet the people working together to advance biodiversity
            conservation, scientific research and sustainable development.
          </motion.p>

        </div>
      </section>

      {/* ================= ADVISORY TEAM ================= */}
      <section className="py-20 bg-gray-950">
        <div className="w-11/12 md:w-4/5 mx-auto">

          <div className="text-center mb-14">
            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Leadership & Guidance
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              ADVISORY TEAM
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

            {/* <p className="text-gray-400 mt-5 max-w-2xl mx-auto">
              Our advisory leadership provides strategic direction, experience
              and guidance to strengthen ACoT's conservation initiatives.
            </p> */}
          </div>

          <div className="grid md:grid-cols-3 gap-10 max-w-5xl mx-auto">
            {advisoryTeam.map((member, index) => (
              <TeamCard
                key={index}
                member={member}
                index={index}
                featured={index === 2}
              />
            ))}
          </div>

        </div>
      </section>

      {/* ================= EXECUTIVE TEAM ================= */}
      <section className="py-20 bg-black">
        <div className="w-11/12 md:w-4/5 mx-auto">

          <div className="text-center mb-14">
            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Driving Our Work
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              EXECUTIVE TEAM
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

            <p className="text-gray-400 mt-5 max-w-2xl mx-auto">
              Our executive team leads research, programmes, partnerships,
              operations and conservation initiatives across ACoT.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {executiveTeam.map((member, index) => (
              <TeamCard
                key={index}
                member={member}
                index={index}
              />
            ))}
          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="relative py-20 bg-lime-400 text-black overflow-hidden">

        <div className="absolute -top-20 -right-20 w-72 h-72 bg-white/10 rounded-full"></div>

        <div className="relative z-10 w-11/12 md:w-4/5 mx-auto text-center">

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold mb-5"
          >
            Together, We Can Make a Difference
          </motion.h2>

          <p className="max-w-2xl mx-auto text-black/70 text-lg mb-8">
            Conservation is a collective effort. Join ACoT in building a
            future where people and nature thrive together.
          </p>

          <button className="bg-black text-white px-8 py-4 rounded-full font-bold hover:bg-gray-900 transition duration-300 shadow-lg">
            SUPPORT OUR WORK
          </button>

        </div>
      </section>

    </div>
  );
};

export default OurTeam;